var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize } from 'styled-system';
import { ArrowRight } from 'pcln-icons';
import { ChipContentWrapper } from '../ChipContentWrapper';
import { getPaletteColor } from '../../utils';
import { Flex } from '../../Flex';
import { Text } from '../../Text';
var ImageWrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  ", "\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  ", "\n"])), getPaletteColor('background.lightest'), function (_a) {
    var theme = _a.theme;
    return theme.radii[2];
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && 'opacity: .33;';
});
var propTypes = __assign(__assign(__assign({}, space.propTypes), fontSize.propTypes), { id: PropTypes.string.isRequired, disabled: PropTypes.bool, selected: PropTypes.bool, facet: PropTypes.string, label: PropTypes.string, bridgeLabel: PropTypes.string, BridgeIcon: PropTypes.node, Icon: PropTypes.node, IconTitle: PropTypes.string, action: PropTypes.shape({
        Icon: PropTypes.node,
        title: PropTypes.string,
    }), Image: PropTypes.object });
var ChipContent = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? undefined : _b, _c = _a.selected, selected = _c === void 0 ? undefined : _c, _d = _a.children, children = _d === void 0 ? undefined : _d, _e = _a.label, label = _e === void 0 ? undefined : _e, 
    /* eslint-disable @typescript-eslint/naming-convention */
    _f = _a.Icon, 
    /* eslint-disable @typescript-eslint/naming-convention */
    Icon = _f === void 0 ? undefined : _f, 
    /* eslint-disable @typescript-eslint/naming-convention */
    _g = _a.IconTitle, 
    /* eslint-disable @typescript-eslint/naming-convention */
    IconTitle = _g === void 0 ? undefined : _g, _h = _a.facet, facet = _h === void 0 ? undefined : _h, _j = _a.action, action = _j === void 0 ? undefined : _j, _k = _a.image, image = _k === void 0 ? undefined : _k, _l = _a.size, size = _l === void 0 ? undefined : _l, _m = _a.bridgeLabel, bridgeLabel = _m === void 0 ? undefined : _m, 
    /* eslint-disable @typescript-eslint/naming-convention */
    _o = _a.BridgeIcon, 
    /* eslint-disable @typescript-eslint/naming-convention */
    BridgeIcon = _o === void 0 ? undefined : _o, props = __rest(_a, ["disabled", "selected", "children", "label", "Icon", "IconTitle", "facet", "action", "image", "size", "bridgeLabel", "BridgeIcon"]);
    return (React.createElement(ChipContentWrapper, __assign({ "data-testid": 'chipContentWrapper', hasChildren: Boolean(children), disabled: disabled, selected: selected, size: size }, props),
        children,
        Boolean(image) && React.createElement(ImageWrapper, { disabled: disabled }, image),
        Boolean(Icon) && React.createElement(Icon, { title: IconTitle, size: '20px' }),
        Boolean(label) && (React.createElement(Text, { regular: true, ml: Boolean(Icon) || Boolean(image) ? 2 : 0 }, label)),
        Boolean(facet) && (React.createElement(Text, { regular: true, ml: 1 }, facet)),
        Boolean(bridgeLabel) && React.createElement(BridgeIcon, { title: 'to', size: '16px', ml: 2 }),
        Boolean(bridgeLabel) && (React.createElement(Text, { regular: true, ml: 2 }, bridgeLabel)),
        Boolean(action === null || action === void 0 ? void 0 : action.Icon) && action.title && React.createElement(action.Icon, { title: action.title, size: '16px', ml: 2 })));
};
ChipContent.displayName = 'Chip';
ChipContent.propTypes = propTypes;
ChipContent.defaultProps = {
    BridgeIcon: ArrowRight,
    size: 'sm',
    color: 'primary',
    py: 1,
    m: 0,
};
export default ChipContent;
var templateObject_1;
//# sourceMappingURL=ChipContent.js.map